import { render, staticRenderFns } from "./SubjectFormComponent.vue?vue&type=template&id=42e268d8"
import script from "./SubjectFormComponent.vue?vue&type=script&lang=js"
export * from "./SubjectFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports